import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';
import ImportMetadata from '../ImportMetadata/ImportMetadata';

import './ViewEntry.scss';
import ViewAllMetadata from "../ViewAllMetadataPopup/ViewAllMetadata";

export class ViewEntry extends Component {
  static propTypes = {
    onClear: PropTypes.func,
    onEdit: PropTypes.func,
    metadata: PropTypes.any,
  }
  state = {
    selectedFileName: ''
  }
  handleShowImportModal = () => {
    this.props.handleShowImportModal();
  }
  handleHideImportModal = () => {
    this.props.handleHideImportModal();
  }

  handleShowModalViewAllMetadata = () => {
    this.props.handleShowModalViewAllMetadata()
  }
  handleHideModalViewAllMetadata = () => {
    this.props.handleHideModalViewAllMetadata()
  }

  handleUpdateDownloadUrl = (e) => {
    this.props.handleUpdateDownloadUrl(e)
  }

  handleImportFromXml = (e) => {
    this.props.handleImportFromXml(e);
  }

  handleImportFromUrl = (e) => {
    this.props.handleImportFromUrl(e);
  }

  handleChangeSelectedImportOption = (e) => {
    this.props.handleChangeSelectedImportOption(e)
  }

  render() {
    const {metadata} = this.props;

    const listAcsItems = metadata ? metadata.assertionConsumerServices.map(
        (d, index) => <li
            key={index}>{d.location}{messageConstants.ACS_INDEX}{d.index}</li>)
        : null;

    return (
        <div className="view-entry-container">
          <h3 className="sba-subtitle">{messageConstants.SP_METADATA}
          </h3>
          <div className="add-edit-subtitle">
            {messageConstants.SBA_METADATA_REQUIRES}
          </div>
          {this.props.metadata ? (<div>

            {metadata.downloadUrl ? (<div>
              <div
                  className="entry-label">{messageConstants.SP_METADATA_PROVIDED_BY_URL}</div>
              <div className="entry-value">
                {metadata.downloadUrl}</div>
            </div>) : null}
            <div className="entry-label">{messageConstants.ENTITY_ID}</div>
            <div className="entry-value">{metadata.entityId}</div>
            <div className="entry-label">{messageConstants.ACS_LABEL}</div>
            <div className="entry-value">
              {listAcsItems.length > 0 ? listAcsItems
                  : (<div
                      className="entry-value">{messageConstants.NOT_SPECIFIED}</div>)}
            </div>

            <div>
              <button
                  type="button"
                  className="view-entry-button"
                  onClick={this.handleShowModalViewAllMetadata}
              >{messageConstants.VIEW_ALL_METADATA}
              </button>
              <button
                  type="button"
                  className="view-entry-button"
                  onClick={this.handleShowImportModal}
              >{messageConstants.REPLACE_METADATA}
              </button>
            </div>
          </div>) : (<div>
            <button
                type="button"
                className="btn btn-md btn-primary get-metadata-button"
                onClick={this.handleShowImportModal}
            >{messageConstants.GET_METADATA}
            </button>
          </div>)}
          <ImportMetadata
              showImportModal={this.props.showImportModal}
              downloadUrl={this.props.downloadUrl}
              handleHideImportModal={this.handleHideImportModal}
              selectedImportOption={this.props.selectedImportOption}
              handleChangeSelectedImportOption={this.handleChangeSelectedImportOption}
              handleImportFromXml={this.handleImportFromXml}
              handleImportFromUrl={this.handleImportFromUrl}
              handleUpdateDownloadUrl={this.handleUpdateDownloadUrl}
          />
          <ViewAllMetadata
              importedMetadata={this.props.metadata}
              showModalViewAllMetadata={this.props.showModalViewAllMetadata}
              handleHideModalViewAllMetadata={this.handleHideModalViewAllMetadata}/>
        </div>

    );
  }
}

export default ViewEntry;



// WEBPACK FOOTER //
// ./src/components/AddSAML/ViewImport/ViewEntry.js